module.exports = __webpack_public_path__ + "img/bg_person_statistics.d543b78d.png";